export const HASURA_CLAIMS_URL = 'https://hasura.io/jwt/claims';
export const HASURA_ORG_ID = 'x-hasura-org-id';
export const HASURA_ALLOWED_ROLES = 'x-hasura-allowed-roles';
export const HASURA_DEFAULT_ROLE = 'x-hasura-default-role';
